import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { checkUserPermissions } from "../lib/userPermissions.ts";
import Permissions from "../lib/userPermissions.ts";
import { useAuth } from "../hooks/useAuth.tsx";

interface RequireAccessProps {
    children: React.ReactNode;
    requiredPermission: keyof Permissions;
}

const RequirePermissions: React.FC<RequireAccessProps> = ({ children, requiredPermission }) => {
    const [access, setAccess] = useState<boolean>(false);
    const [redirecting, setRedirecting] = useState<boolean>(false);
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth(); 

    useEffect(() => {
        const fetchUserRole = async () => {
            
            if (!isAuthenticated) {
                setRedirecting(true);
                navigate('/', { replace: true });
                return;
            }

            const permissions = await checkUserPermissions();
            if (!permissions[requiredPermission]) {
                setRedirecting(true);
                navigate('/');
            } else {
                setAccess(true);
            }
        };
        fetchUserRole();
    }, [requiredPermission, navigate, isAuthenticated]);

    if (redirecting) {
        return <div className="main-container">Acesso negado. Você será redirecionado para a página inicial.</div>;
    }

    if (!access) {
        return null;
    }

    return <>{children}</>;
};

export default RequirePermissions;
